import { render, staticRenderFns } from "./pondGuardSettings.vue?vue&type=template&id=4e84ab9a&"
import script from "./pondGuardSettings.vue?vue&type=script&lang=js&"
export * from "./pondGuardSettings.vue?vue&type=script&lang=js&"
import style0 from "./pondGuardSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports